module.exports = __webpack_public_path__ + "img/DZ.5efc03c7.png";